import { ROUTER_BASE_PATH } from '../../constants/siteConstants';

const baseRouterPath = ROUTER_BASE_PATH;
export default [
  {
    id: 'doc-24',
    allowVisitor: true,
    title: 'Agenda de Turnos',
    image: `${process.env.PUBLIC_URL}/images/leftNavigation/doc24.png`,
    to: '',
  },
  {
    id: 'datos-personales',
    allowVisitor: true,
    title: 'DATOS PERSONALES',
    image: `${process.env.PUBLIC_URL}/images/leftNavigation/mis_datos.png`,
    to: `/tramitesonline/datos-personales`,
  },
  {
    id: 'consulta-de facturas/pagos',
    allowVisitor: true,
    title: 'CONSULTA DE FACTURAS Y PAGOS',
    image: `${process.env.PUBLIC_URL}/images/leftNavigation/autorizaciones.png`,
    to: `/tramitesonline/consulta-pagos-facturas`,
  },
  {
    id: 'consulta-de liquidacion',
    allowVisitor: true,
    title: 'CONSULTA DE LIQUIDACIÓN',
    image: `${process.env.PUBLIC_URL}/images/leftNavigation/facturas.png`,
    to: `/tramitesonline/consulta-de-liquidacion`,
    tagManagerName: 'Consulta de Liquidación',
  },
  // {
  //   id: 'reporte-transaccional',
  //   allowVisitor: true,
  //   title: 'REPORTE TRANSACCIONAL',
  //   image: reporteImg,
  //   to: `/tramitesonline/reporte-transaccional`,
  // },
  {
    id: 'validador-de-asociados',
    allowVisitor: true,
    title: 'VALIDADOR DE ASOCIADOS',
    image: `${process.env.PUBLIC_URL}/images/leftNavigation/credencialprovi.png`,
    to: `/tramitesonline/validar-afiliado`,
  },
  {
    id: 'tramites-de autorizaciones',
    allowVisitor: true,
    title: 'TRÁMITES DE AUTORIZACIONES',
    image: `${process.env.PUBLIC_URL}/images/leftNavigation/detalle.png`,
    to: `/tramitesonline/tramites-de-autorizaciones`,
  },
  {
    id: 'censos',
    allowVisitor: true,
    title: 'CENSOS',
    image: `${process.env.PUBLIC_URL}/images/leftNavigation/censos.png`,
    to: `/tramitesonline/censos`,
  },

  {
    id: 'calificaciones',
    allowVisitor: false,
    title: 'CALIFICACIONES',
    image: `${process.env.PUBLIC_URL}/images/leftNavigation/calificaciones.png`,
    to: `/tramitesonline/mis-calificaciones`,
  },
  // {
  //   id: 'receta-digital',
  //   allowVisitor: false,
  //   title: 'RECETA DIGITAL',
  //   image: facturasPagosImg,
  //   to: `/tramitesonline/receta-digital`,
  // },
  {
    id: 'cap',
    allowVisitor: true,
    title: 'CAP WEB - CENTRO DE ATENCIÓN A PRESTADORES',
    image: `${process.env.PUBLIC_URL}/images/leftNavigation/cap.png`,
    to: `/tramitesonline/capweb`,
  },
  {
    id: 'reportes',
    allowVisitor: true,
    title: 'TRÁMITES CONECTIVIDAD',
    image: `${process.env.PUBLIC_URL}/images/leftNavigation/validar_credencial.png`,
    to: `/tramitesonline/tramites-conectividad`,
  },
];
